import React, { useState } from "react";


export default function CourseEnroll() {
  const [selectedCourse, setSelectedCourse] = useState(null);

  const courses = [
    {
      id: 1,
      title: "Ethical Hacking",
      description: "Learn penetration testing and security assessment techniques.",
      details:
        "CEH trains cybersecurity professionals to think like hackers. It includes hands-on learning of ethical hacking techniques, malware analysis, vulnerability assessment, footprinting, and penetration testing tools like Nmap, Metasploit, and Burp Suite. Graduates can legally and ethically detect vulnerabilities in systems.",
    },
    {
      id: 2,
      title: "Cyber Security",
      description: "Become a cyber defender against emerging threats.",
      details:
        "Cybersecurity is the practice of protecting systems, networks, and data from digital attacks. It includes defensive measures like firewalls, antivirus tools, risk assessment, and compliance. Professionals in this field ensure the confidentiality, integrity, and availability of information.",
    },
    {
      id: 3,
      title: "CompTIA",
      description: "Get ready for the leading IT certifications like Network+, A+.",
      details:
        "CompTIA Security+ is an entry-level yet comprehensive certification covering cybersecurity fundamentals. It teaches threat management, cryptography, identity management, and incident response. The certification is vendor-neutral, making it a great starting point for IT professionals pursuing security roles.",
    },
    {
      id: 4,
      title: "CCNA",
      description: "Networking fundamentals – routing and switching configurations.",
      details:
        "CCNA provides foundational knowledge in networking. It covers topics like IP addressing, subnetting, routing and switching, network security basics, and wireless networking. It’s ideal for beginners aiming to understand and configure Cisco network devices. A certified professional can troubleshoot and secure network infrastructures.",
    },
     {
      id: 5,
      title: "Bug Hunting",
      description: "Networking fundamentals – routing and switching configurations.",
      details:
        "Bug hunting is the process of finding security flaws in applications and platforms. Ethical hackers report these bugs to companies via bug bounty programs like HackerOne or Bugcrowd. It requires expertise in identifying and exploiting vulnerabilities like XSS, SQLi, or CSRF.",
    },
     {
      id: 6,
      title: "Pentesting",
      description: "Networking fundamentals – routing and switching configurations.",
      details:
        "Pentesting simulates cyberattacks on systems to identify security weaknesses before hackers do. It includes planning, scanning, exploiting vulnerabilities, and reporting. Pentesters use tools like Kali Linux and manual techniques. This process strengthens an organization’s defense posture through real-world testing.",
    },
  ];

  return (
    <div className="enrollCourse-container">
      <h1 className="enrollCourse-title">Join One of Our Top Courses</h1>
      <p className="enrollCourse-subtitle">Click on any course to view details</p>

      <div className="enrollCourse-grid">
        {courses.map((course) => (
          <div
            key={course.id}
            className="enrollCourse-card"
            onClick={() => setSelectedCourse(course)}
          >
            <h2 className="enrollCourse-cardTitle">{course.title}</h2>
            <p className="enrollCourse-cardDesc">{course.description}</p>
          </div>
        ))}
      </div>

      {selectedCourse && (
        <div className="enrollCourse-modalOverlay" onClick={() => setSelectedCourse(null)}>
          <div
            className="enrollCourse-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="enrollCourse-modalTitle">{selectedCourse.title}</h2>
            <p className="enrollCourse-modalDetails">{selectedCourse.details}</p>
            <button
              className="enrollCourse-closeBtn"
              onClick={() => setSelectedCourse(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
